<template>
    <div class="autocomplete__wrapper">
        <div class="autocomplete__input">
            <input
                type="text"
                :value="value"
                :class="[inputClass]"
                :placeholder="placeholder"
                autocomplete="off"
                @input="$emit('input', $event.target.value)"
                @click="isFocused = true"
                @focusin="isFocused = true"
                @blur="onBlur"
            />
            <input type="hidden" :value="selectedValue"/>
        </div>

        <div v-if="showDropdown" class="autocomplete__dropdown">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="autocomplete__dropdown-item"
                :class="{ 'autocomplete__dropdown-item--highlight': item[propNameValue] === selectedValue }"
                @click="setSelectedValue(item)"
            >
                <span>{{ item[propNameText] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
// Original: https://github.com/huytran17/typeahead-autocomplete
import { prop } from 'ramda'

export default {
    props: {
        value: { type: String, required: true },
        placeholder: { type: String, default: () => '' },
        inputClass: { type: String, default: () => '' },
        minSearchLength: { type: Number, default: 3 },

        /**
         * Prop name which is label of selected item
         */
        propNameText: { type: String, default: () => 'text' },

        /**
         * Prop name which is value of selected item
         */
        propNameValue: { type: String, default: () => 'value' },
    },

    data () {
        return {
            items: [],
            selectedValue: null,
            isFocused: false,
        }
    },

    computed: {
        showDropdown () {
            return this.items.length && this.isFocused
        },
    },

    watch: {
        value () {
            if (this.value.length < this.minSearchLength) {
                this.items = []
            } else {
                this.fetchRemoteData()
            }
        },
    },

    methods: {
        onBlur () {
            setTimeout(() => (this.isFocused = false), 200)
        },

        setSelectedValue (item) {
            const value = prop(this.propNameValue, item)

            this.$emit('input', value)
            this.$emit('chooseItem', value)
            this.isFocused = false
        },

        async fetchRemoteData () {
            try {
                const response = await this.$http.get(`/document/auto-complete?search=${this.value}`)
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.items = response.data
            } catch (e) {
                console.error(e)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.autocomplete {
    &__wrapper {
        position: relative;
    }

    &__input input:first-child {
        width: 100%;
    }

    &__input input:first-child:focus {
        outline: none !important;
    }

    &__dropdown {
        max-height: 206px;
        height: min-content;
        overflow-y: auto;
        border: 1px solid $secondary-color;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        top: 100%;
        background: #fff;
        z-index: 99;
     }

    &__dropdown-item {
        color: $secondary-color !important;
        font-size: $font-size-14;
        padding: 6px 8px;
        cursor: pointer;

        @include interaction {
            background: rgba($primary-color, 0.2);
        }

        &--highlight {
            background: rgba($primary-color, 0.2);
        }
     }
}
</style>
